/** kc,90 options offered by both the single-element and multi-edit Auflagerpressung forms. */
export const K_C_90_OPTIONS: { value: number; label: string }[] = [
  { value: 1.0, label: '1.0' },
  { value: 1.25, label: '1.25' },
  { value: 1.5, label: '1.5' },
  { value: 1.75, label: '1.75' },
  { value: 1.4, label: '1.4' },
  { value: 1.9, label: '1.9' },
]

/** f_c_90_k is persisted in N/m² and displayed in N/mm². */
export const FC90K_CONVERSION_FACTOR = 1000000
